module.exports = __webpack_public_path__ + "static/img/icon_phone.82dc6fe7.png";